<template>
  <div>Sellers works !</div>
</template>

<script>
export default {
  name: 'Sellers',
}
</script>

<style>

</style>
